import { Button, TextButton } from "@volumental/common";
import type { JSX } from "react";
import { useTranslation } from "react-i18next";

interface FooterButtonsProps {
  onClick: () => void;
  onSkip?: () => void;
  loading: boolean;
  buttonText?: string;
}

export function FooterButtons({ onClick, onSkip, loading, buttonText }: FooterButtonsProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col m-6 justify-center items-center">
      <Button onClick={onClick} loading={loading}>
        {buttonText ?? t("button.submit")}
      </Button>
      {onSkip !== undefined && (
        <TextButton onClick={onSkip} disabled={loading}>
          {t("button.idontknow")}
        </TextButton>
      )}
    </div>
  );
}
